<script setup lang="ts">
definePageMeta({
  title: 'Contact Us',
  label: 'Contact',
  icon: 'i-carbon-chat',
  description: 'Have a question? Need support with an ICS product? General inquiries here.',
  order: 7,
})

const route = useRoute()

const atContactRoot = computed(() => /\/contact\/?$/.test(route.path))
</script>

<template>
  <PageRoot>
    <PageHead
      theme="dark"
      :show-nav="false"
      :at-root="atContactRoot"
    >
      <dl class="text-xl w-content pb-8 pt-4 gap-y-6 grid grid-cols-[min-content_auto] drop-shadow f-gap-x-12-32 sm:grid-cols-[min-content_min-content_min-content_auto]">
        <dt>
          <div class="flex items-center">
            <span class="i-carbon-phone mr-3 inline-block size-7 -ml-.5" />Phone
          </div>
        </dt>
        <dd>1-720-652-6777</dd>
        <dt class="sm:f-ml-0-32">
          <div class="flex items-center">
            <span class="i-carbon-printer mr-3 inline-block size-7 -ml-.5" />Fax
          </div>
        </dt>
        <dd>1-720-652-6778</dd>
        <dt>
          <div class="flex items-center">
            <span class="i-carbon-email mr-3 inline-block size-7 -ml-.5" />Email
          </div>
        </dt>
        <dd>
          <a
            class="whitespace-nowrap"
            href="mailto:sales@ics-mfg.com"
          >sales@ics-mfg.com</a>
        </dd>
        <dt class="sm:f-ml-0-32">
          <div class="flex items-center">
            <span class="i-carbon-location mr-3 inline-block size-7 -ml-.5" />Address
          </div>
        </dt>
        <dd>
          <address class="not-italic">
            410 S Sunset St, Suite A<br>Longmont CO, 80501
          </address>
        </dd>
      </dl>
      <template #parallax>
        <EffectBgMountains :photo="2" />
      </template>
    </PageHead>
    <PageBody>
      <BlockContent
        v-if="atContactRoot"
        element="section"
        class="space-y-4"
      >
        <div class="flex flex-col gap-y-4 f-gap-x-32-64 sm:flex-row">
          <AButton
            label="Request a Quote"
            size="xlarge"
            color="blue"
            material="empty"
            icon="i-carbon-arrow-right"
            icon-side="right"
            to="/contact/rfq"
          />
          <h2 class="subpage-title sm:order-first">
            Send Us an Email
          </h2>
        </div>
        <p>Have a question? Need support with an ICS product? General inquiries here.</p>
        <HubspotForm form-id="3b30ac80-4223-4caa-9f7f-8b9d0e04fadd" />
      </BlockContent>
      <NuxtPage v-else />
    </PageBody>
  </PageRoot>
</template>
